import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const HeroSection = () => {
  const [heroImage, setHeroImage] = useState('');

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/settings`);
      setHeroImage(response.data.heroImage);
    } catch (error) {
      console.error('Erro ao carregar configurações');
    }
  };

  if (!heroImage) {
    return null; // Don't show hero section if no banner image
  }

  return (
    <section 
      className="relative w-full"
      style={{
        backgroundImage: `url(/uploads/${heroImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '400px',
        height: '50vh',
        maxHeight: '600px'
      }}
    >
      {/* Optional overlay for better text readability if needed in future */}
    </section>
  );
};

export default HeroSection;